'use client';

// hooks
import { useResponsive } from '@/hooks';
// @mui
import { Stack, Typography } from '@mui/material';

export default function HeroSliderNavigation() {
  const isDesktop = useResponsive('up', 'md');
  return (
    <Stack
      sx={{ width: '100%', py: 2 }}
      flexDirection="column"
      direction="column"
      justifyContent="center"
    >
      {/* <Stack direction={isDesktop ? 'row' : 'column'} justifyContent="center" alignItems="center">
        <Stack direction="row" alignItems="center">
          <i className="icon-lightbulb" style={{ fontSize: '20px' }} />
          <Typography
            sx={{
              marginTop: 0,
              marginRight: 3,
              fontSize: '20px',
              lineHeight: '25px',
              color: '#151F2F',
            }}
          >
            Innovate
          </Typography>
        </Stack>
        <Stack direction="row" alignItems="center">
          <i className="icon-group" style={{ fontSize: '20px' }} />
          <Typography
            sx={{
              marginTop: 0,
              marginRight: 3,
              fontSize: '20px',
              lineHeight: '25px',
              color: '#151F2F',
            }}
          >
            Connect
          </Typography>
        </Stack>
        <Stack direction="row" alignItems="center">
          <i className="icon-chart-pie-outline" style={{ fontSize: '20px' }} />
          <Typography
            sx={{
              marginTop: 0,
              marginRight: 3,
              fontSize: '20px',
              lineHeight: '25px',
              color: '#151F2F',
            }}
          >
            Execute
          </Typography>
        </Stack>
      </Stack>  */}
    </Stack>
  );
}
